import { Button, Checkbox, Divider, Form, Input, InputNumber, Modal, Spin, Tooltip } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import PageLayout from '../../../../components/PageLayout';
import { Action, DropdownAction, GET, GETWITH, IfElse, JSXMap, Model, POST, POSTFormData, QueryDetail, QueryOrder, QueryParam, deleteInArray, errorCatch, makeFormData, updateInArray, useAuth, useTranslateContext } from 'fennec-ui';
import YImage from '../../../../../common/YImage';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { getIndexColorLighter, goTo } from '../../../../../common/Tool';
import FedTooltip from '../../../../components/Tooltip';
import { CalculatorOutlined, ExclamationCircleOutlined, FileDoneOutlined, IssuesCloseOutlined, LoadingOutlined } from '@ant-design/icons';
import User, { UserName } from '../../../../../common/User';
import EmojiTextArea from '../../../../../common/EmojiTextArea';
import Link from 'antd/es/typography/Link';
import VkGruppiVMastereList from './VkGruppiVMastereList';
import EventListItem from '../../../../components/EventListItem';
import ModernUserSelection from '../../../../components/ModernUserSelection';
import ModernObjectSelection from '../../../../components/ModernObjectSelection';
import uuid from 'react-uuid';

var _ = require('lodash');

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

// POST - "/api/mastervkpostov/create" 
// GET - "/api/mastervkpostov/delete/{id}"
// GET - "/api/mastervkpostov/list"
// GET - "/api/mastervkpostov/byid/{id}"

const IntegerValueCell = (props) => {
    const auth = useAuth();
    const t = useTranslateContext();

    const { item, value: initialValue, onChange, style } = props;

    const [value, setValue] = React.useState(initialValue);
    const [lastError, setLastError] = React.useState();
    // const [readyToChange, setReadyToChange] = React.useState(false);

    const onError = (e) => {
        if (initialValue != value) {
            setLastError(e);
        }
    };
    const onEnter = () => {
        // setReadyToChange(false);
        onChange(value, onError);
    };
    const onBlur = () => {
        // if (readyToChange) {
        //     setReadyToChange(false);
        // } else 
        if (initialValue != value) {
            onChange(value, onError);
        }
    };
    React.useEffect(() => {
        setLastError(undefined);
        // setReadyToChange(false);
    }, [value]);
    React.useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    let fixed = item?.document?.fixed;
    let colorClass = (fixed) ?
        (item?.toPayment == item?.calcPayment) ? `bg-blue border-darkgreen` : `bg-grey border-darkgreen` :
        (item?.toPayment == item?.calcPayment) ? `bg-blue border-blue` : `bg-grey border-blue`;
    const stateClass = () => {
        // if (readyToChange) {
        //     return "change"
        // }
        if (initialValue != value) {
            if (lastError) {
                return "error";
            }
            return "warning";
        }
        return ""
    };
    if (!fixed) {
        return (
            <div style={style} onClick={(e) => { e.preventDefault() }}>
                <div style={{ position: "relative" }}>
                    <InputNumber
                        key={item.ID}
                        min={0}
                        className={`bg ${colorClass} pointer ${stateClass()}`}
                        value={value}
                        onChange={v => {
                            setValue((v) ? v : undefined);
                        }}
                        placeholder=""
                        style={{ fontSize: "12px", textAlign: "center", cursor: "pointer", padding: "0px" }}
                        onBlurCapture={onBlur}
                        onPressEnter={onEnter}
                    />
                    {lastError && <div style={{
                        position: "absolute",
                        top: "2px",
                        left: "3px",
                        fontSize: "14px"
                    }}>
                        {<Tooltip title={(lastError && lastError.message) ? lastError.message : ""}>
                            <i className="fa fa-exclamation" style={{ color: "red" }}></i>
                        </Tooltip>}
                    </div>}
                </div>
            </div>
        )
    }
    return (<div key={item.ID} className={`bg ${colorClass} dark-1`} style={style}>{item?.toPayment}</div>);
};
const StringValueCell = (props) => {
    const auth = useAuth();
    const t = useTranslateContext();

    const { item, value: initialValue, onChange, style, className } = props;

    const [value, setValue] = React.useState(initialValue);
    const [lastError, setLastError] = React.useState();

    const onError = (e) => {
        if (initialValue != value) {
            setLastError(e);
        }
    };
    const onEnter = () => {
        onChange(value, onError);
    };
    const onBlur = () => {
        if (initialValue != value) {
            onChange(value, onError);
        }
    };
    React.useEffect(() => {
        setLastError(undefined);
    }, [value]);
    React.useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    let fixed = item?.document?.fixed;
    let colorClass = (fixed) ?
        (!item?.kommentarii) ? `bg-blue border-darkgreen` : `bg-grey border-darkgreen` :
        (!item?.kommentarii) ? `bg-blue border-blue` : `bg-grey border-blue`;
    const stateClass = () => {
        if (initialValue != value) {
            if (lastError) {
                return "error";
            }
            return "warning";
        }
        return ""
    };
    if (!fixed) {
        return (
            <div style={{ height: "100%", ...style }} onClick={(e) => { e.preventDefault() }}>
                <div style={{ height: "100%", position: "relative" }}>
                    <Input
                        key={item.ID}
                        className={`bg ${colorClass} pointer ${stateClass()}`}
                        value={value}
                        onChange={v => {
                            setValue(v.target.value);
                        }}
                        placeholder=""
                        style={{ height: "100%", fontSize: "12px", textAlign: "left", cursor: "pointer", padding: "0px 5px" }}
                        onBlurCapture={onBlur}
                        onPressEnter={onEnter}
                    />
                    {lastError && <div style={{
                        position: "absolute",
                        top: "2px",
                        left: "3px",
                        fontSize: "14px"
                    }}>
                        {<Tooltip title={(lastError && lastError.message) ? lastError.message : ""}>
                            <i className="fa fa-exclamation" style={{ color: "red" }}></i>
                        </Tooltip>}
                    </div>}
                </div>
            </div>
        )
    }
    return (<div key={item.ID} className={`bg ${colorClass} dark-1`} style={style}>{item?.kommentarii}</div>);
};

// POST /api/vkposts/createorupdate - MultipartFormData
// GET /api/vkposts/delete/{id}
// GET /api/vkposts/list/{id}
// GET /api/vkposts/byid/{id}

// POST "/api/vkgruppivmastere/create"
// POST "/api/vkgruppivmastere/update"
// POST "/api/vkgruppivmastere/prioritet"
// GET "/api/vkgruppivmastere/delete/{id}"
// GET "/api/vkgruppivmastere/list/{masterid}"
// GET "/api/vkgruppivmastere/byid/{id}"

// POST "/api/razmeshcheniepostov/create"
// POST "/api/razmeshcheniepostov/update"
// "/api/razmeshcheniepostov/delete/{id}"
// "/api/razmeshcheniepostov/list/{masterid}"
// "/api/razmeshcheniepostov/byid/{id}"

const ReplaceTextWithParameters = (props) => {
    const { auth, loading, master, form, fieldsValues, setLoading, object } = props;

    let tipSsilkiDlyaSaitaID = fieldsValues?.["tipPosta"]?.itemByProperty?.tipSsilkiDlyaSaitaID || object?.tipPosta?.tipSsilkiDlyaSaitaID;
    let tekstSsilkiNaSaite = fieldsValues?.["tipPosta"]?.itemByProperty?.tekstSsilkiNaSaite || object?.tipPosta?.tekstSsilkiNaSaite;
    let tekstPosta = fieldsValues?.["tipPosta"]?.itemByProperty?.tekstPosta || object?.tipPosta?.tekstPosta;
    let tipPostaID = fieldsValues?.["tipPosta"]?.itemByProperty?.ID || object?.tipPosta?.ID;

    let parametriTipovPostov = fieldsValues?.["tipPosta"]?.itemByProperty?.parametriTipovPostovTipPosta;
    // console.log(fieldsValues, parametriTipovPostov);

    const metaByParams = useMemo(() => {
        let params = []
        for (let i = 0; i < parametriTipovPostov?.length; i++) {
            const param = parametriTipovPostov[i];

            switch (param.tipParametraID) {
                case 1: // Пользователь
                    params.push({
                        label: "Пользователь",
                        // name: "param" + param?.ID,
                        name: param?.key,
                        type: "func",
                        render: (auth, item, value, onChange, onAfterChange) => (<Action
                            auth={auth}
                            action={(values, unlock, close, { collection, setCollection }) => {
                                // console.log(values);
                                // setSelectedUserID(values?.polzovatel?.ID)
                                onChange(values?.polzovatel)
                                close();
                            }}
                            triggerOptions={{
                                type: "primary"
                            }}
                            form={ModernUserSelection}
                            options={{
                                initialValues: {},
                            }}
                            modal={{
                                minWidth: "250px",
                                title: "Выбор пользователя",
                            }}

                            mode="func"
                            trigger={(click) => (<div onClick={click} className="bg bg-fwhite pointer" style={{ minHeight: "32px", padding: "5px 5px 10px 5px", textAlign: "start", border: "1px solid #dedede" }}>
                                <div style={{ width: "100%" }}>
                                    {!!value && <User item={value} />}
                                </div>
                            </div>)}
                        />)
                    });
                    break;
                case 2: // Серия
                    params.push({
                        label: "Серия",
                        // name: "param" + param?.ID,
                        name: param?.key,
                        type: "object",
                        relation: {
                            display: (item) => {
                                return item.nazvanie
                            },
                            reference: { object: "Serii", property: "ID", source: "/api/serii/list/com" },
                            type: "many-one",
                        },
                        queryFilter: [
                            QueryOrder("ID", "ASC")
                        ]
                    });
                    break;
                case 3: // Фестиваль
                    params.push({
                        label: "Фестиваль",
                        // name: "param" + param?.ID,
                        name: param?.key,
                        type: "object",
                        relation: {
                            display: (item) => {
                                return item.nazvanie
                            },
                            reference: { object: "Festivali", property: "ID", source: "/api/festivali/list/com" },
                            type: "many-one",
                        },
                        queryFilter: [
                            QueryOrder("ID", "ASC")
                        ]
                    });
                    break;
                case 4: // "Мероприятие"
                    params.push({
                        label: "Мероприятие",
                        // name: "param" + param?.ID,
                        name: param?.key,
                        type: "object",
                        mode: "dialog",
                        modal: { width: "700px" },
                        relation: {
                            uiFilter: () => [
                                {
                                    label: "Дата начала",
                                    name: "nachaloSorevnovaniya",
                                    type: "date",
                                    filterType: "range",
                                    sort: true,
                                    filter: true,

                                    sorted: "ASC",
                                    filtered: [dayjs().subtract(5, "days"), dayjs().add(1, "years")],
                                },
                                {   // Тип мероприятия
                                    label: "Тип мероприятия",
                                    name: "tipMeropriyatiya",
                                    filterType: "group",
                                    display: (o) => o.opisanie,
                                    sort: true,
                                    filter: true
                                },
                                {   // Уровень мероприятия
                                    label: "Уровень мероприятия",
                                    name: "urovenMeropriyatiya",
                                    filterType: "group",
                                    display: (o) => o.opisanie,
                                    sort: true,
                                    filter: true
                                },
                                {   // Место проведения
                                    label: "Место проведения",
                                    name: "mestoProvedeniya",
                                    filterType: "group",
                                    display: (o) => o.name,
                                    sort: true,
                                    filter: true
                                },
                            ],
                            displayString: (item) => {
                                return dayjs(item.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " + item.nazvanieMeropriyatiya + ", " + item?.mestoProvedeniya?.name
                            },
                            display: (item) => {
                                return (
                                    <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>

                                        <div style={{ width: "32px", minHeight: "32px", overflow: "hidden", borderRadius: "4px" }}>
                                            <YImage item={item} width={32} hidePreview={true} />
                                        </div>

                                        <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                            <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                                <a href={`/fed/event/${item.ID}`}>
                                                    <span style={{ fontWeight: "600" }}>{item.nazvanieMeropriyatiya}</span>
                                                </a>
                                            </div>
                                            <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                                                <span style={{
                                                    marginRight: "5px",
                                                    borderRadius: "5px",

                                                    backgroundColor: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                                                    color: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "black" : "white",
                                                    fontWeight: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "400" : "600",
                                                    fontSize: "12px",


                                                    boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                                                    padding: "2px 4px"
                                                }}>{dayjs(item.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                                                <span>{item?.mestoProvedeniya?.name}</span>
                                            </div>
                                        </div>
                                    </div>
                                )
                            },
                            reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                            type: "many-one",
                        },
                        queryFilter: [
                            QueryDetail("combobox"),
                            QueryOrder("nachaloSorevnovaniya", "DESC")
                        ]
                    })
                    break;
                case 5: // Судья
                    params.push({
                        label: "Судья",
                        // name: "param" + param?.ID,
                        name: param?.key,
                        type: "func",
                        render: (auth, item, value, onChange, onAfterChange) => {
                            return (<Action
                                auth={auth}
                                action={(values, unlock, close, { collection, setCollection }) => {
                                    onChange(values?.object)
                                    close();
                                }}
                                triggerOptions={{
                                    type: "primary"
                                }}
                                filters={[
                                    QueryParam("w-nnu-sudya.ID", "true")
                                ]}
                                form={ModernObjectSelection}
                                options={{
                                    initialValues: {},
                                }}
                                modal={{
                                    minWidth: "250px",
                                    title: "Выбор судьи",
                                }}

                                mode="func"
                                trigger={(click) => (<div onClick={click} className="bg bg-fwhite pointer" style={{ minHeight: "32px", padding: "5px 5px 10px 5px", textAlign: "start", border: "1px solid #dedede" }}>
                                    <div style={{ width: "100%" }}>
                                        {!!value && <div>{value?.render(value, uuid())}</div>}
                                    </div>
                                </div>)}
                            />)
                        }
                    });
                    break;
                case 6: // Танцор
                    params.push({
                        label: "Танцор",
                        // name: "param" + param?.ID,
                        name: param?.key,
                        type: "func",
                        render: (auth, item, value, onChange, onAfterChange) => {
                            return (<Action
                                auth={auth}
                                action={(values, unlock, close, { collection, setCollection }) => {
                                    onChange(values?.object)
                                    close();
                                }}
                                triggerOptions={{
                                    type: "primary"
                                }}
                                filters={[
                                    QueryParam("w-nnu-tantsor.ID", "true")
                                ]}
                                form={ModernObjectSelection}
                                options={{
                                    initialValues: {},
                                }}
                                modal={{
                                    minWidth: "250px",
                                    title: "Выбор танцора",
                                }}

                                mode="func"
                                trigger={(click) => (<div onClick={click} className="bg bg-fwhite pointer" style={{ minHeight: "32px", padding: "5px 5px 10px 5px", textAlign: "start", border: "1px solid #dedede" }}>
                                    <div style={{ width: "100%" }}>
                                        {!!value && <div>{value?.render(value, uuid())}</div>}
                                    </div>
                                </div>)}
                            />)
                        }
                    });
                    break;
                case 7: // Преподаватель
                    params.push({
                        label: "Преподаватель",
                        // name: "param" + param?.ID,
                        name: param?.key,
                        type: "func",
                        render: (auth, item, value, onChange, onAfterChange) => {
                            return (<Action
                                auth={auth}
                                action={(values, unlock, close, { collection, setCollection }) => {
                                    onChange(values?.object)
                                    close();
                                }}
                                triggerOptions={{
                                    type: "primary"
                                }}
                                filters={[
                                    QueryParam("w-nnu-prepodavatel.ID", "true")
                                ]}
                                form={ModernObjectSelection}
                                options={{
                                    initialValues: {},
                                }}
                                modal={{
                                    minWidth: "250px",
                                    title: "Выбор преподавателья",
                                }}

                                mode="func"
                                trigger={(click) => (<div onClick={click} className="bg bg-fwhite pointer" style={{ minHeight: "32px", padding: "5px 5px 10px 5px", textAlign: "start", border: "1px solid #dedede" }}>
                                    <div style={{ width: "100%" }}>
                                        {!!value && <div>{value?.render(value, uuid())}</div>}
                                    </div>
                                </div>)}
                            />)
                        }
                    });
                    break;
                case 8: // Организатор
                    params.push({
                        label: "Организатор",
                        // name: "param" + param?.ID,
                        name: param?.key,
                        type: "func",
                        render: (auth, item, value, onChange, onAfterChange) => {
                            return (<Action
                                auth={auth}
                                action={(values, unlock, close, { collection, setCollection }) => {
                                    onChange(values?.object)
                                    close();
                                }}
                                triggerOptions={{
                                    type: "primary"
                                }}
                                filters={[
                                    QueryParam("w-nnu-organizator.ID", "true")
                                ]}
                                form={ModernObjectSelection}
                                options={{
                                    initialValues: {},
                                }}
                                modal={{
                                    minWidth: "250px",
                                    title: "Выбор организатора",
                                }}

                                mode="func"
                                trigger={(click) => (<div onClick={click} className="bg bg-fwhite pointer" style={{ minHeight: "32px", padding: "5px 5px 10px 5px", textAlign: "start", border: "1px solid #dedede" }}>
                                    <div style={{ width: "100%" }}>
                                        {!!value && <div>{value?.render(value, uuid())}</div>}
                                    </div>
                                </div>)}
                            />)
                        }
                    });
                    break;
                case 9: // Школа
                    params.push({
                        label: "Школа",
                        // name: "param" + param?.ID,
                        name: param?.key,
                        type: "func",
                        render: (auth, item, value, onChange, onAfterChange) => {
                            return (<Action
                                auth={auth}
                                action={(values, unlock, close, { collection, setCollection }) => {
                                    onChange(values?.object)
                                    close();
                                }}
                                triggerOptions={{
                                    type: "primary"
                                }}
                                filters={[
                                    QueryParam("w-nnu-shkola.ID", "true")
                                ]}
                                form={ModernObjectSelection}
                                options={{
                                    initialValues: {},
                                }}
                                modal={{
                                    minWidth: "250px",
                                    title: "Выбор школы",
                                }}

                                mode="func"
                                trigger={(click) => (<div onClick={click} className="bg bg-fwhite pointer" style={{ minHeight: "32px", padding: "5px 5px 10px 5px", textAlign: "start", border: "1px solid #dedede" }}>
                                    <div style={{ width: "100%" }}>
                                        {!!value && <div>{value?.render(value, uuid())}</div>}
                                    </div>
                                </div>)}
                            />)
                        }
                    });
                    break;
                case 10: // Коллектив
                    params.push({
                        label: "Коллектив",
                        // name: "param" + param?.ID,
                        name: param?.key,
                        type: "func",
                        render: (auth, item, value, onChange, onAfterChange) => {
                            return (<Action
                                auth={auth}
                                action={(values, unlock, close, { collection, setCollection }) => {
                                    onChange(values?.object)
                                    close();
                                }}
                                triggerOptions={{
                                    type: "primary"
                                }}
                                filters={[
                                    QueryParam("w-nnu-kollektiv.ID", "true")
                                ]}
                                form={ModernObjectSelection}
                                options={{
                                    initialValues: {},
                                }}
                                modal={{
                                    minWidth: "250px",
                                    title: "Выбор коллектива",
                                }}

                                mode="func"
                                trigger={(click) => (<div onClick={click} className="bg bg-fwhite pointer" style={{ minHeight: "32px", padding: "5px 5px 10px 5px", textAlign: "start", border: "1px solid #dedede" }}>
                                    <div style={{ width: "100%" }}>
                                        {!!value && <div>{value?.render(value, uuid())}</div>}
                                    </div>
                                </div>)}
                            />)
                        }
                    });
                    break;
                case 11: // Танцевальная пара
                    params.push({
                        label: "Танцевальная пара",
                        // name: "param" + param?.ID,
                        name: param?.key,
                        type: "func",
                        render: (auth, item, value, onChange, onAfterChange) => {
                            return (<Action
                                auth={auth}
                                action={(values, unlock, close, { collection, setCollection }) => {
                                    onChange(values?.object)
                                    close();
                                }}
                                triggerOptions={{
                                    type: "primary"
                                }}
                                filters={[
                                    QueryParam("w-nnu-para.ID", "true")
                                ]}
                                form={ModernObjectSelection}
                                options={{
                                    initialValues: {},
                                }}
                                modal={{
                                    minWidth: "250px",
                                    title: "Выбор танцевальной пары",
                                }}

                                mode="func"
                                trigger={(click) => (<div onClick={click} className="bg bg-fwhite pointer" style={{ minHeight: "32px", padding: "5px 5px 10px 5px", textAlign: "start", border: "1px solid #dedede" }}>
                                    <div style={{ width: "100%" }}>
                                        {!!value && <div>{value?.render(value, uuid())}</div>}
                                    </div>
                                </div>)}
                            />)
                        }
                    });
                    break;
                case 12: // Член Федерации
                    break;
                case 13: // Региональное отделени
                    params.push({
                        label: "Региональное отделение",
                        // name: "param" + param?.ID,
                        name: param?.key,
                        type: "func",
                        render: (auth, item, value, onChange, onAfterChange) => {
                            return (<Action
                                auth={auth}
                                action={(values, unlock, close, { collection, setCollection }) => {
                                    onChange(values?.object)
                                    close();
                                }}
                                triggerOptions={{
                                    type: "primary"
                                }}
                                filters={[
                                    QueryParam("w-nnu-regionalnoeOtdelenie.ID", "true")
                                ]}
                                form={ModernObjectSelection}
                                options={{
                                    initialValues: {},
                                }}
                                modal={{
                                    minWidth: "250px",
                                    title: "Выбор регионального отделения",
                                }}

                                mode="func"
                                trigger={(click) => (<div onClick={click} className="bg bg-fwhite pointer" style={{ minHeight: "32px", padding: "5px 5px 10px 5px", textAlign: "start", border: "1px solid #dedede" }}>
                                    <div style={{ width: "100%" }}>
                                        {!!value && <div>{value?.render(value, uuid())}</div>}
                                    </div>
                                </div>)}
                            />)
                        }
                    });
                    break;
                default:
                    break;
            }

        }
        return params;
    }, [parametriTipovPostov, fieldsValues]);

    if (parametriTipovPostov && parametriTipovPostov?.length > 0) {
        return (<Action
            auth={auth}
            action={(values, unlock, close, { collection, setCollection }) => {
                let newObj = {};
                let array = Object.entries(values);
                for (let i = 0; i < array.length; i++) {
                    const [key, value] = array[i];
                    let keyName = (key.endsWith('ID') === true && key.endsWith('.ID') !== true) ? key.slice(0, -2) : key;
                    let valueByKey = (_.isObject(value) ? value?.ID : value)
                    newObj[keyName] = valueByKey;
                }

                POST(auth, `/api/tipipostov/replacetext/${tipPostaID}/${master?.meropriyatieID}`, newObj,
                    ({ data }) => {
                        setLoading(false)
                        if (form && fieldsValues) {
                            form.setFieldsValue({
                                tipSsilkiDlyaSaitaID: tipSsilkiDlyaSaitaID,
                                tekstSsilkiNaSaite: tekstSsilkiNaSaite,
                                tekst: data,
                            });
                        }
                        close();
                    }, (err) => errorCatch(err, () => { setLoading(false); close(); })
                );
            }}
            triggerOptions={{
                type: "primary"
            }}
            form={Model}
            meta={metaByParams}
            options={{
                initialValues: {},
            }}
            modal={{
                minWidth: "250px",
                title: "Заполните параметры шаблона",
            }}
            mode={"func"}
            trigger={(click) => (<Button
                loading={loading}
                type="dashed"
                style={{ marginBottom: "15px" }}
                onClick={click}>Копировать из шаблона</Button>)}
        />)
    } else {
        return (<Button
            loading={loading}
            type="dashed"
            style={{ marginBottom: "15px" }}
            onClick={() => {
                setLoading(true)
                POST(auth, `/api/tipipostov/replacetext/${tipPostaID}/${master?.meropriyatieID}`, {},
                    ({ data }) => {
                        setLoading(false)
                        if (form && fieldsValues) {
                            form.setFieldsValue({
                                tipSsilkiDlyaSaitaID: tipSsilkiDlyaSaitaID,
                                tekstSsilkiNaSaite: tekstSsilkiNaSaite,
                                tekst: data,
                            });
                        }
                    }, (err) => errorCatch(err, () => { setLoading(false) })
                );
            }}>Копировать из шаблона</Button>)
    }
}

function VkpostsTable(props) {
    const { auth, master } = props;
    const [tableData, setTableData] = useState()
    const [tableColumns, setTableColumns] = useState()
    const [tableCells, setTableCells] = useState()
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (master?.ID) {
            setLoading(true)
            GET(auth, `/api/vkposts/list/${master?.ID}`, ({ data }) => {
                setTableData(data)
                setLoading(false)
            }, (err) => errorCatch(err, () => setLoading(false)))

            setLoading(true)
            GETWITH(auth, `/api/vkgruppivmastere/list/${master?.ID}`,
                [
                    QueryOrder("prioritet", "DESC")
                ], ({ data }) => {
                    setTableColumns(data)
                    setLoading(false)
                }, (err) => errorCatch(err, () => setLoading(false)))
        }
    }, [master?.ID])

    useEffect(() => {
        if (master?.ID) {
            setLoading(true)
            GET(auth, `/api/razmeshcheniepostov/list/${master?.ID}`, ({ data }) => {
                setTableCells(data)
                setLoading(false)
            }, (err) => errorCatch(err, () => setLoading(false)))
        }
    }, [master?.ID, tableData])

    const createPost = useCallback(() => {
        setLoading(true)
        GET(auth, `/api/vkposts/createorupdate/${master?.ID}`, ({ data }) => {
            setTableData(data)
            setLoading(false)
        }, (err) => errorCatch(err, () => setLoading(false)))
    }, [master?.ID])

    const EmojiField = useCallback((auth, item, value, onChange, onAfterChange) => {
        return (<EmojiTextArea
            rows={25}
            auth={auth}
            // item={item}
            value={value}
            onChange={onChange}
            onAfterChange={onAfterChange}
            copyButton={true}
        />)
    }, [auth])

    const statistika = useCallback((all, waiting, published, viewed) => {
        return (<Tooltip title={<div>
            <div>
                <i className="fa fa-circle-o" style={{ fontSize: "11px" }}></i> Всего {all}
            </div>
            <div>
                <i className="fa fa-clock-o" style={{ fontSize: "11px" }}></i> Ожидают {waiting}
            </div>
            <div>
                <i className="fa fa-check" style={{ fontSize: "11px", color: "green" }}></i> Опубликовано {published}
            </div>
            <div>
                <i className="fa fa-eye" style={{ fontSize: "11px" }}></i> Просмотрено {viewed}
            </div>
        </div>}>
            <div className='bg bg-orange dark-5'>
                <div>
                    <i className="fa fa-circle-o" style={{ fontSize: "11px" }}></i> {all}
                </div>
                <div>
                    <i className="fa fa-clock-o" style={{ fontSize: "11px" }}></i> {waiting}
                </div>
                <div>
                    <i className="fa fa-check" style={{ fontSize: "11px", color: "green" }}></i> {published}
                </div>
                <div>
                    <i className="fa fa-eye" style={{ fontSize: "11px" }}></i> {viewed}
                </div>
            </div>
        </Tooltip>)
    }, [auth])
    const editingCompleted = useCallback((item) => {
        POST(auth, `/api/razmeshcheniepostov/editingcompleted`, {
            ID: item?.ID,
            editingCompleted: !item?.editingCompleted
        }, ({ data }) => {
            setTableCells(o => updateInArray(o, data))
        }, errorCatch)
    }, [auth, tableCells])

    return (<div>
        {master?.meropriyatie && <EventListItem
            event={master?.meropriyatie}

            // adminButton={true}
            hideBuyButton={true}
            hideDetailButton={true}

            size={"medium"}
        />}
        <div className='bg bg-grey' style={{ display: "flex", justifyContent: "space-between", padding: "3px", marginBottom: "5px" }}>
            <div style={{ display: "flex", gap: "3px" }}>
                <Action
                    key="vkpost"
                    auth={auth}
                    modal={{
                        width: "650px"
                    }}
                    options={{
                        initialValues: {
                            tekst: "" // `Уважаемый #firstname #lastname! Мы рады сообщить вам о нашем новом мероприятии. Ждем!`
                        }
                    }}
                    action={(values, unlock, close) => {
                        POSTFormData(auth, `/api/vkposts/createorupdate`,
                            makeFormData(
                                {
                                    ...values,
                                    masterID: master?.ID,
                                    serialized: JSON.stringify({ ...values, masterID: master?.ID, })
                                }),
                            ({ data }) => {
                                setTableData(o => updateInArray(o, data))
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    }}
                    form={Model}
                    meta={[
                        {
                            label: "Тип поста",
                            name: "tipPosta",
                            type: "object",
                            relation: {
                                display: (item) => {
                                    return item.nazvanie
                                },
                                reference: { object: "TipiPostov", property: "ID", source: "/api/tipipostov/list" },
                                type: "many-one",
                            },
                            queryFilter: [
                                QueryOrder("ID", "ASC")
                            ]
                        },
                        {
                            type: "func",
                            render: (auth, item, { form, data, object, contextObject, funcStat, fieldsValues }) => {
                                // let tipSsilkiDlyaSaitaID = fieldsValues?.["tipPosta"]?.itemByProperty?.tipSsilkiDlyaSaitaID;
                                // let tekstSsilkiNaSaite = fieldsValues?.["tipPosta"]?.itemByProperty?.tekstSsilkiNaSaite;
                                // let tekstPosta = fieldsValues?.["tipPosta"]?.itemByProperty?.tekstPosta;
                                // let tipPostaID = fieldsValues?.["tipPosta"]?.itemByProperty?.ID;

                                // let parametriTipovPostovTipPosta = fieldsValues?.["tipPosta"]?.itemByProperty?.parametriTipovPostovTipPosta;
                                // console.log(parametriTipovPostovTipPosta);

                                return (<ReplaceTextWithParameters
                                    auth={auth}
                                    loading={loading}
                                    master={master}
                                    form={form}
                                    fieldsValues={fieldsValues}
                                    setLoading={setLoading}
                                    object={object}
                                />)
                                // return (<Button
                                //     loading={loading}
                                //     type="dashed"
                                //     // danger={(form.getFieldValue("tipSsilkiDlyaSaitaID") !== tipSsilkiDlyaSaitaID ||
                                //     //     form.getFieldValue("tekstSsilkiNaSaite") !== tekstSsilkiNaSaite ||
                                //     //     form.getFieldValue("tekst") !== tekstPosta) ? true : false}
                                //     style={{ marginBottom: "15px" }}
                                //     onClick={() => {
                                //         setLoading(true)
                                //         GET(auth, `/api/tipipostov/replacetext/${tipPostaID}/${master?.meropriyatieID}`,
                                //             ({ data }) => {
                                //                 setLoading(false)
                                //                 if (form && fieldsValues) {
                                //                     form.setFieldsValue({
                                //                         tipSsilkiDlyaSaitaID: tipSsilkiDlyaSaitaID,
                                //                         tekstSsilkiNaSaite: tekstSsilkiNaSaite,
                                //                         tekst: data,
                                //                     });
                                //                 }
                                //             }, (err) => errorCatch(err, () => { setLoading(false) })
                                //         );
                                //     }}>Копировать из шаблона</Button>)
                            }
                        },
                        {
                            label: "Тип ссылки для сайта",
                            name: "tipSsilkiDlyaSaita",
                            type: "object",
                            relation: {
                                display: (item) => {
                                    return item.opisanie
                                },
                                reference: { object: "TipiSsilokVSotsSetyakh", property: "ID" },
                                type: "many-one",
                            },
                            queryFilter: [
                                QueryOrder("ID", "ASC")
                            ]
                        },
                        {
                            label: "Текст ссылки на сайте",
                            name: "tekstSsilkiNaSaite",
                            type: "string"
                        },
                        {
                            label: "Текст поста",
                            name: "tekst",
                            type: "func",
                            render: EmojiField,
                        },
                        // {
                        //     label: "Добавляемые файлы",
                        //     name: "file",
                        //     type: "files",
                        //     accept: ".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .jpg, .png, .gif, .pdf, .xls, .xlsx, .txt, .svg, .mp4"
                        // }
                    ]}
                    mode={"func"}
                    trigger={(click) => (
                        <Tooltip title="Создать пост">
                            <div className={`bg bg-grey pointer`} onClick={click} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <i className="fa fa-plus" style={{ fontSize: "12px" }}></i>}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                    )}
                />
            </div>
            <div style={{ display: "flex", gap: "3px" }}>
                <Action
                    key="vkgruppivmastere"
                    auth={auth}
                    title={"Города серий"}
                    modal={{
                        width: "600px",
                        bodyStyle: { padding: "12px" }
                    }}
                    action={(values, unlock, close) => {

                    }}
                    master={master}
                    readonly={true}
                    noAntForm={true}
                    updateVkGruppi={setTableColumns}
                    form={VkGruppiVMastereList}
                    mode={"func"}
                    trigger={(click) => (
                        <Tooltip title="Управление группами">
                            <div className={`bg bg-grey pointer`} onClick={click} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {!loading && <i className="fa fa-vk" style={{ fontSize: "12px" }}></i>}
                                {loading && <Spin
                                    indicator={
                                        <LoadingOutlined
                                            style={{
                                                color: "grey",
                                                fontSize: 12,
                                            }}
                                            spin
                                        />
                                    }
                                />}
                            </div>
                        </Tooltip>
                    )}
                />
            </div>
        </div>
        <div className='scrollable' style={{ backgroundColor: "white", height: "80vh" }}>
            <table className="table fixed-header" style={{ fontSize: "13px", lineHeight: "normal" }}>
                <thead>
                    <tr>
                        <th className={`wrap fixed`} style={{ minWidth: "200px", backgroundColor: "white" }}>
                            <div className='bg bg-grey dark-1'>Название</div>
                        </th>
                        <th className="wrap fixed" style={{ left: "200px", minWidth: "50px", maxWidth: "50px", backgroundColor: "white" }}>
                            <div className='bg bg-orange dark-5 border-orange'>
                                {/* <i className="fa fa-share-square-o"></i> */}
                                <i className="fa fa-pie-chart"></i>
                            </div>
                        </th>
                        <th className="wrap fixed" style={{ left: "250px", minWidth: "50px", maxWidth: "50px", backgroundColor: "white" }}>
                            <div className='bg bg-orange dark-5 border-orange'>
                                <Tooltip title="Разместить">
                                    <i className="fa fa-share-square-o"></i>
                                </Tooltip>
                            </div>
                        </th>
                        {JSXMap(tableColumns, (item, cidx) => {
                            let color = getIndexColorLighter(cidx, 0.20);

                            return (<th className="wrap" style={{ minWidth: "175px", fontWeight: "300" }} key={cidx}>
                                <div className="bg bg-grey" style={{ backgroundColor: color }}>
                                    <Link style={{ color: "rgba(0,0,0,0.85)" }} target='_blank' href={item?.gruppa?.ssilka}><i className="fa fa-external-link" style={{ fontSize: "11px" }}></i> {item?.gruppa?.nazvanie}</Link>
                                </div>
                            </th>)
                        })}
                    </tr>
                </thead>
                <tbody style={{ fontSize: "12px" }}>
                    {JSXMap(tableData || [], (item, cidx) => {
                        let all = 0, events = 0, waiting = 0, published = 0, viewed = 0;
                        for (let i = 0; i < tableColumns?.length; i++) {
                            let group = tableColumns[i];
                            let o = tableCells?.find(e => e.postID == item?.ID && e.gruppaID == group?.ID);
                            if (o) {
                                all++;
                            }
                            if (o && o?.faktVremyaPublikatsii) {
                                published++;
                            }
                            if (o && o?.editingCompleted) {
                                viewed++;
                            }
                            if (o && o?.dataVremya && !o?.faktVremyaPublikatsii) {
                                waiting++;
                            }
                        }
                        return (<tr key={cidx}>
                            <td className={`fixed`} style={{ minWidth: "200px", backgroundColor: "white", height: '1px' }}>
                                <div className='bg bg-transparent' style={{ display: "flex", justifyContent: "space-between", padding: "3px", marginBottom: "5px" }}>
                                    <div style={{ display: "flex", flexDirection: "column", gap: "3px", flex: "1 1 auto", overflow: "hidden", textAlign: "left" }}>
                                        <div style={{
                                            fontWeight: "bold",
                                            textWrap: "nowrap",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}>{item?.tipPosta?.nazvanie}</div>
                                        <div style={{
                                            fontSize: "11px", fontStyle: "italic", color: "rgba(0,0,0,.85)",
                                            textWrap: "nowrap",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}>{item?.tipPosta?.kommentarii}</div>

                                        {item?.tipSsilkiDlyaSaita?.opisanie && <div style={{
                                            fontSize: "11px", fontStyle: "italic", color: "rgba(0,0,0,.65)",
                                            textWrap: "nowrap",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}><i className="fa fa-globe" style={{ fontSize: "10px", color: "blue" }}></i> {item?.tipSsilkiDlyaSaita?.opisanie}</div>}
                                        {item?.tekstSsilkiNaSaite && <div style={{
                                            fontSize: "11px", fontStyle: "italic", color: "rgba(0,0,0,.65)",
                                            textWrap: "nowrap",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}><i className="fa fa-font" style={{ fontSize: "10px", color: "blue" }}></i> {item?.tekstSsilkiNaSaite}</div>}

                                    </div>
                                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "3px", flex: "0 0 50px" }}>
                                        <DropdownAction
                                            icon={<i className="fa fa-ellipsis-h" style={{ fontSize: "12px" }}></i>}
                                            buttonStyle={{ border: "none" }}
                                            items={[
                                                {
                                                    title: "Изменить",
                                                    mode: "MenuItem",
                                                    auth: auth,
                                                    modal: {
                                                        width: "650px"
                                                    },
                                                    options: {
                                                        initialValues: {
                                                            ...item
                                                        }
                                                    },
                                                    action: (values, unlock, close) => {
                                                        POSTFormData(auth, `/api/vkposts/createorupdate`,
                                                            makeFormData(
                                                                {
                                                                    ...item,
                                                                    ...values,
                                                                    masterID: master?.ID,
                                                                    serialized: JSON.stringify({ ...item, ...values, masterID: master?.ID, })
                                                                }),
                                                            ({ data }) => {
                                                                setTableData(o => updateInArray(o, data))
                                                                close();
                                                            },
                                                            (err) => errorCatch(err, unlock)
                                                        );
                                                    },
                                                    object: item,
                                                    form: Model,
                                                    meta: [
                                                        {
                                                            label: "Тип поста",
                                                            name: "tipPosta",
                                                            type: "object",
                                                            relation: {
                                                                display: (item) => {
                                                                    return item.nazvanie
                                                                },
                                                                reference: { object: "TipiPostov", property: "ID", source: "/api/tipipostov/list" },
                                                                type: "many-one",
                                                            },
                                                            queryFilter: [
                                                                QueryOrder("ID", "ASC")
                                                            ]
                                                        },
                                                        {
                                                            type: "func",
                                                            render: (auth, item, { form, data, object, contextObject, funcStat, fieldsValues }) => {
                                                                // let tipSsilkiDlyaSaitaID = fieldsValues?.["tipPosta"]?.itemByProperty?.tipSsilkiDlyaSaitaID || object?.tipPosta?.tipSsilkiDlyaSaitaID;
                                                                // let tekstSsilkiNaSaite = fieldsValues?.["tipPosta"]?.itemByProperty?.tekstSsilkiNaSaite || object?.tipPosta?.tekstSsilkiNaSaite;
                                                                // let tekstPosta = fieldsValues?.["tipPosta"]?.itemByProperty?.tekstPosta || object?.tipPosta?.tekstPosta;
                                                                // let tipPostaID = fieldsValues?.["tipPosta"]?.itemByProperty?.ID || object?.tipPosta?.ID;

                                                                return (<ReplaceTextWithParameters
                                                                    auth={auth}
                                                                    loading={loading}
                                                                    master={master}
                                                                    form={form}
                                                                    fieldsValues={fieldsValues}
                                                                    setLoading={setLoading}
                                                                    object={object}
                                                                />)
                                                                // return (<Button
                                                                //     loading={loading}
                                                                //     type="dashed"
                                                                //     // danger={(form.getFieldValue("tipSsilkiDlyaSaitaID") !== tipSsilkiDlyaSaitaID ||
                                                                //     //     form.getFieldValue("tekstSsilkiNaSaite") !== tekstSsilkiNaSaite ||
                                                                //     //     form.getFieldValue("tekst") !== tekstPosta) ? true : false}
                                                                //     style={{ marginBottom: "15px" }}
                                                                //     onClick={() => {
                                                                //         setLoading(true)
                                                                //         GET(auth, `/api/tipipostov/replacetext/${tipPostaID}/${master?.meropriyatieID}`,
                                                                //             ({ data }) => {
                                                                //                 setLoading(false)
                                                                //                 if (form && fieldsValues) {
                                                                //                     form.setFieldsValue({
                                                                //                         tipSsilkiDlyaSaitaID: tipSsilkiDlyaSaitaID,
                                                                //                         tekstSsilkiNaSaite: tekstSsilkiNaSaite,
                                                                //                         tekst: data,
                                                                //                     });
                                                                //                 }
                                                                //             }, (err) => errorCatch(err, () => { setLoading(false) })
                                                                //         );
                                                                //     }}>Копировать из шаблона</Button>)
                                                            }
                                                        },
                                                        {
                                                            label: "Тип ссылки для сайта",
                                                            name: "tipSsilkiDlyaSaita",
                                                            type: "object",
                                                            relation: {
                                                                display: (item) => {
                                                                    return item.opisanie
                                                                },
                                                                reference: { object: "TipiSsilokVSotsSetyakh", property: "ID" },
                                                                type: "many-one",
                                                            },
                                                            queryFilter: [
                                                                QueryOrder("ID", "ASC")
                                                            ]
                                                        },
                                                        {
                                                            label: "Текст ссылки на сайте",
                                                            name: "tekstSsilkiNaSaite",
                                                            type: "string"
                                                        },
                                                        {
                                                            label: "Текст поста",
                                                            name: "tekst",
                                                            type: "func",
                                                            render: EmojiField,
                                                        },
                                                        // {
                                                        //     label: "Добавляемые файлы",
                                                        //     name: "file",
                                                        //     type: "files",
                                                        //     accept: ".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .jpg, .png, .gif, .pdf, .xls, .xlsx, .txt, .svg, .mp4"
                                                        // }
                                                    ],
                                                },
                                                {
                                                    title: <span style={{ color: "red" }}>Удалить</span>,
                                                    auth: auth,
                                                    mode: "MenuItem",
                                                    action: (values, unlock, close) => {
                                                        Modal.confirm({
                                                            title: `Вы уверены что хотите удалить пост?`,
                                                            icon: <ExclamationCircleOutlined />,
                                                            content: <div>
                                                                <div style={{ fontWeight: "bold" }}>{item?.tipPosta?.nazvanie}</div>
                                                                <div style={{ fontSize: "11px", fontStyle: "italic", color: "rgba(0,0,0,.85)" }}>{item?.tipPosta?.kommentarii}</div>
                                                            </div>,
                                                            okText: "Да",
                                                            okType: 'danger',
                                                            cancelText: "Нет",
                                                            onOk: () => {
                                                                GET(auth, `/api/vkposts/delete/${item.ID}`,
                                                                    () => {
                                                                        setTableData(o => deleteInArray(o, item))
                                                                    }, errorCatch
                                                                );
                                                            },
                                                        });
                                                    }
                                                }
                                            ]} />
                                    </div>
                                </div>

                            </td>
                            <td className={`fixed fill`} style={{ left: "200px", minWidth: "50px", maxWidth: "50px", backgroundColor: "white", height: '1px' }}>
                                {statistika(all, waiting, published, viewed)}
                            </td>
                            <td className={`fixed`} style={{ left: "250px", minWidth: "50px", maxWidth: "50px", backgroundColor: "white", height: '1px' }}>
                                <Action
                                    key="razmeshchenie"
                                    auth={auth}
                                    action={(values, unlock, close) => {
                                        Modal.confirm({
                                            title: `Вы уверены что хотите разместить пост в группах?`,
                                            icon: <ExclamationCircleOutlined />,
                                            content: <div>
                                                <div style={{ fontWeight: "bold" }}>{item?.tipPosta?.nazvanie}</div>
                                                <div style={{ fontSize: "11px", fontStyle: "italic", color: "rgba(0,0,0,.85)" }}>{item?.tipPosta?.kommentarii}</div>
                                            </div>,
                                            okText: "Да",
                                            okType: 'danger',
                                            cancelText: "Нет",
                                            onOk: () => {
                                                GET(auth, `/api/vkposts/send/${item.ID}`,
                                                    ({ data }) => {
                                                        setTableData(o => updateInArray(o, data))
                                                        // close()
                                                    }, err => errorCatch(err, unlock)
                                                );
                                            },
                                        });


                                    }}
                                    mode={"func"}
                                    trigger={(click) => (
                                        <div onClick={click} className="bg bg-orange dark-1 border-transparent pointer" style={{ fontWeight: (item?.razmestit) ? "bold" : "normal", height: "100%" }}>
                                            {(item?.razmestit) ? "Да" : "Нет"}
                                        </div>
                                    )}
                                />
                            </td>
                            {JSXMap(tableColumns, (group, cidx) => {
                                let o = tableCells?.find(e => e.postID == item?.ID && e.gruppaID == group?.ID)

                                return (<td className="wrap" style={{ fontWeight: "300", height: '1px', backgroundColor: "white" }} key={cidx}>
                                    <Action
                                        key="razmeshcheniePostov"
                                        auth={auth}
                                        options={{
                                            initialValues: {
                                                dataVremya: o?.dataVremya
                                            }
                                        }}
                                        action={(values, unlock, close) => {
                                            if (!o) {
                                                POST(auth, `/api/razmeshcheniepostov/create`, {
                                                    gruppaID: group?.ID,
                                                    postID: item?.ID,
                                                    dataVremya: values.dataVremya,
                                                }, ({ data }) => {
                                                    setTableCells(o => updateInArray(o, data))
                                                    close()
                                                }, err => errorCatch(err, unlock))
                                            } else if (values?.dataVremya) {
                                                POST(auth, `/api/razmeshcheniepostov/update`, {
                                                    ...o,
                                                    dataVremya: values.dataVremya,
                                                }, ({ data }) => {
                                                    setTableCells(o => updateInArray(o, data))
                                                    close()
                                                }, err => errorCatch(err, unlock))
                                            } else {
                                                GET(auth, `/api/razmeshcheniepostov/delete/${o.ID}`,
                                                    () => {
                                                        setTableCells(os => deleteInArray(os, o))
                                                        close()
                                                    }, err => errorCatch(err, unlock)
                                                );
                                            }
                                        }}
                                        object={o}
                                        form={Model}
                                        meta={[
                                            {
                                                label: "Дата и время",
                                                name: "dataVremya",
                                                type: "datetime"
                                            }
                                        ]}
                                        mode={"func"}
                                        trigger={(click) => (
                                            <div onClick={(!o?.razmeshcheno) ? click : undefined} className={`bg ${(o && o?.razmeshcheno) ? (!!o?.vkPostId) ? "bg-green dark-3 border-transparent" : "bg-orange dark-3 border-transparent" : (o) ? "bg-blue border-transparent pointer" : "bg-grey light-3 border-transparent pointer"}`}
                                                style={{ height: "100%", position: "relative" }}>
                                                {((!!o?.vkPostId) || (!o?.vkPostId && !!o?.vkPostIdWait)) && <div style={{ position: "absolute", top: "5px", right: "5px" }}>
                                                    <Tooltip title={(!!o?.editingCompleted) ? "Завершен" : "Не завершен"}>
                                                        <div onClick={e => editingCompleted(o)} className='bg bg-grey pointer' style={{ color: "rgba(0,0,0,.65)", minWidth: "13px", minHeight: "13px", display: "flex", justifyContent: "center", alignContent: "center", alignItems: "center" }}>
                                                            {!!o?.editingCompleted && <i className="fa fa-check-square-o"></i>}
                                                            {!o?.editingCompleted && <i className="fa fa-square-o" style={{ color: "orangered" }}></i>}
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                                <div>{(o?.dataVremya) ? <span><i className="fa fa-clock-o" style={{ fontSize: "11px" }}></i> <span style={{ fontStyle: (o?.faktVremyaPublikatsii) ? "normal" : "normal" }}>{dayjs(o?.dataVremya).format("DD.MM.YYYY HH:mm:ss")}</span></span> : undefined}</div>
                                                <div>{(o?.faktVremyaPublikatsii) ? <span><i className="fa fa-check" style={{ fontSize: "11px", color: "green" }}></i> <span style={{ fontWeight: (o?.faktVremyaPublikatsii) ? "bold" : "normal" }}>{dayjs(o?.faktVremyaPublikatsii).format("DD.MM.YYYY HH:mm:ss")}</span></span> : undefined}</div>
                                                {(!!o?.vkPostId) && <div><Link style={{ fontSize: "12px" }} target='_blank' href={`https://vk.com/club${group?.gruppa?.vkId}?w=wall-${group?.gruppa?.vkId}_${o?.vkPostId}`}><i className="fa fa-external-link" style={{ fontSize: "11px" }}></i> Ссылка</Link></div>}
                                                {(!o?.vkPostId && !!o?.vkPostIdWait) && <div><Link style={{ fontSize: "12px" }} target='_blank' href={`https://vk.com/wall-${group?.gruppa?.vkId}?postponed=1&w=wall-${group?.gruppa?.vkId}_${o?.vkPostIdWait}`}><i className="fa fa-external-link" style={{ fontSize: "11px" }}></i> Ссылка</Link></div>}
                                            </div>
                                        )}
                                    />

                                </td>)
                            })}
                        </tr>)
                    })}
                </tbody>
            </table>
        </div>
    </div >)
}

export default function PostsCreatorMastersByID(props) {
    let { id } = useParams();
    const { auth } = props;

    const [mastervkpostov, setMastervkpostov] = useState(undefined);
    useEffect(() => {
        GET(auth, `/api/mastervkpostov/byid/${id}`,
            ({ data }) => {
                if (data) {
                    setMastervkpostov(data);
                }
            }, errorCatch);
    }, [id])

    return (
        <PageLayout hideSider={true}>
            <div style={{ backgroundColor: "white", padding: "0 15px", borderRadius: "4px" }}>
                <div style={{ padding: "10px" }}>
                    <Divider type="horizontal" orientation="left">
                        Посты в группах
                    </Divider>
                    <VkpostsTable auth={auth} master={mastervkpostov} />
                </div>
            </div>
        </PageLayout>
    );
}
